import type { MapResultEntry } from "../SelectHelper";

export type OptionGroup = {
  label: string;
  group: MapResultEntry[];
};

export function snapshotSelectedIds(selectedIds: number[] | null): number[] {
  return [...(selectedIds ?? [])];
}

export function buildOptionGroups(
  options: MapResultEntry[],
  selectedIds: number[] | null,
  labels: { selected: string; remaining: string },
): OptionGroup[] | null {
  if (selectedIds == null || selectedIds.length === 0) {
    return null;
  }

  const selectedIdSet = new Set(selectedIds);
  const groups = [
    {
      label: labels.selected,
      group: options.filter((option) => selectedIdSet.has(option.id)),
    },
    {
      label: labels.remaining,
      group: options.filter((option) => !selectedIdSet.has(option.id)),
    },
  ];

  return groups.filter((group) => group.group.length > 0);
}
